$(document).on('click', e => {
  const target = e.target;
  const scrollTargetSelector = target.dataset && target.dataset.scrollTo;

  if (!scrollTargetSelector) {
    return;
  }

  e.preventDefault();

  document
    .querySelector(scrollTargetSelector)
    .scrollIntoView({ behavior: 'smooth' });
});
